import * as React from 'react'

import { CheckIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { IGroupByOption } from '../../../CompactGroupByPicker/CompactGroupByFilter'
import MenuCloser from '../../../MenuCloser'

interface IProps {
  selectedMode: string
  onHide: () => void
  onGroupByChange: (bandType: string) => void
  groupByOptions: IGroupByOption[]
}

const groupBy = 'Group by'

@observer
export default class GroupByModal extends React.Component<IProps> {
  public render() {
    const { onHide } = this.props

    return (
      <MenuCloser
        closeMenu={onHide}
        className="absolute users-group-by beautiful-shadow brada4 bg-white z-index-120"
      >
        <div className="row text grey-light uppercase pa10">{groupBy}</div>
        {this.renderContent()}
      </MenuCloser>
    )
  }

  private renderContent(): JSX.Element {
    const { groupByOptions, selectedMode, onGroupByChange } = this.props

    return (
      <div className="col mw160">
        {groupByOptions.map(({ title, groupByType, icon }, index) => {
          const isOptionSelected = groupByType === selectedMode

          return (
            <div
              key={index}
              className={classList({
                'row y-center pa10': true,
                'highlighted-hover pointer': !isOptionSelected,
              })}
              onClick={onGroupByChange.bind(this, groupByType)}
            >
              <div className="text large row">
                {icon}
                {title}
              </div>
              {isOptionSelected && (
                <CheckIcon size={16} className="tw:text-primary" />
              )}
            </div>
          )
        })}
      </div>
    )
  }
}
